import React from "react";
import { Phone, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinalCtaBanner() {
  return <section data-section-id="257732" id="צרו-קשר-עכשיו" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="bg-primary text-primary-foreground rounded-lg p-8 md:p-16 flex flex-col items-center text-center space-y-6 max-w-4xl mx-auto shadow-xl">
          <h2 className="text-3xl md:text-5xl font-bold font-default tracking-tight">
            זקוקים למטפל סיעודי באופן מיידי?
          </h2>
          
          <p className="text-lg md:text-2xl text-primary-foreground/90 max-w-2xl font-default leading-relaxed">
            אנחנו כאן בשבילכם. צוות המומחים שלנו זמין לספק מענה מקצועי ומהיר תוך 5 שעות בלבד, כדי להבטיח ליקיריכם את הטיפול הטוב ביותר.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 pt-6 w-full sm:w-auto">
            <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 w-full sm:w-auto font-bold text-lg shadow-md">
              <Link to="/ContactPage">
                <Phone className="ml-2 size-5" />
                חייגו עכשיו לייעוץ
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="bg-transparent border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary w-full sm:w-auto font-semibold text-lg">
              <Link to="/HomePage">
                <ArrowLeft className="ml-2 size-5" />
                חזרה לדף הבית
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}